<template>
    <div class="page-content g9">
        <Accord title="Events">
            <h4>Significant events generated during the simulation run</h4>

            <Accord title="Stock-outs and expiration tracker">
                <EventsMap chart-name="eventsMap"></EventsMap>

                <DownloadLog></DownloadLog>
            </Accord>

        </Accord>
    </div>
</template>

<script>
    import Accord from "../../Accord.vue"
    import EventsMap from "../Charts/EventsMap.vue"
    import DownloadLog from "../DownloadLog.vue"

    export default {
        components: {
            Accord,
            EventsMap,
            DownloadLog
        }
    }
</script>
